<script>
	import DropdownCheckbox from "../../../../components/DropdownCheckbox/DropdownCheckbox.svelte";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import LimitSize from "../../../../components/SizeSelect/limitSize.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import { initPage, masterData } from "src/store/store";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import { debounce } from "lodash";
	import { navigate } from "svelte-routing";
	import { caseOriginDropdownCheckBoxOptions } from "src/utils/options";
	import LastUpdatedDateTime from "src/components/LastUpdatedDateTime/LastUpdatedDateTime.svelte";
	import {
		carAssetOwnersDropdownCheckBoxOptions,
		getOrDefault,
		updateCheckboxOptions,
	} from "src/utils/misc";

	export let handleVehicleSearch = () => {};
	export let changeSearchParams = () => {};
	export let params = {};

	let carAssetOwnerIsOpen = false;
	let caseOriginIsOpen = false;

	$: assetOwnerOptions = updateCheckboxOptions(
		carAssetOwnersDropdownCheckBoxOptions($masterData.carAssetOwners),
		params.assetOwnerId
	);

	$: caseOriginCheckboxOptions = updateCheckboxOptions(
		caseOriginDropdownCheckBoxOptions,
		params.caseOrigin
	);

	$: plateNo = getOrDefault(params.plateNo, "");
	$: vehicleId = getOrDefault(params.vehicleId, "");
	$: createdAt = getOrDefault(params.createdAt, "");
	$: caseNo = getOrDefault(params.caseNo, "");
	$: quotationCreatedFrom = getOrDefault(params.quotationCreatedFrom, "");
	$: quotationCreatedTo = getOrDefault(params.quotationCreatedTo, "");

	function toggleCarAssetOwner() {
		carAssetOwnerIsOpen = !carAssetOwnerIsOpen;
	}

	function toggleCaseOrigin() {
		caseOriginIsOpen = !caseOriginIsOpen;
	}

	const debouncedInput = debounce((e) => handleChange(e), 1000);

	function handleChange(value) {
		changeSearchParams({ ...value, pageNumber: 1, page: 1 });
		initPage.set(1);
	}

	function resetFilter() {
		initPage.set(1);
		navigate("/issues/case-management?tab=PreBilling");
		changeSearchParams("");
	}
</script>

<Row style="padding-right: 0">
	<Col xs={12}>
		<Row>
			<Col xs={10}>
				<Row class="gx-2">
					<Col>
						<CustomInput
							placeholder="Case No"
							search
							bind:value={caseNo}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="caseNo"
						/>
					</Col>
					<Col>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									createdAt: e.detail,
								});
							}}
							value={createdAt}
							name="createdAt"
							isRange={false}
							placeholder={"Case Created"}
						/>
					</Col>
					<Col>
						<CustomSearch
							loadOptions={handleVehicleSearch}
							id={`plateNo`}
							type="text"
							placeholder={`Vehicle No`}
							bind:value={plateNo}
							containerClasses={`search-icon`}
							onSelect={(e) => {
								plateNo = e.detail.label;
								vehicleId = e.detail.value;
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
							handleClear={() => {
								plateNo = "";
								vehicleId = "";
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
						/>
					</Col>
					<Col>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									quotationCreatedFrom: e.detail[0],
									quotationCreatedTo: e.detail[1],
								});
							}}
							value={quotationCreatedFrom && quotationCreatedTo
								? [quotationCreatedFrom, quotationCreatedTo]
								: []}
							name="dateRange"
							isRange={true}
							placeholder={"Quotation Created"}
							disabledDates={(date) => {
								const today = new Date();
								return date > today;
							}}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		<Row class="mb-3">
			<Col xs={9}>
				<Row class="gx-2">
					<Col xs={3}>
						<DropdownCheckbox
							categoryName="All Case Origin"
							options={caseOriginCheckboxOptions}
							id="caseOrigin"
							isOpen={caseOriginIsOpen}
							toggle={toggleCaseOrigin}
							refetch={handleChange}
						/>
					</Col>
					<Col xs={3}>
						<DropdownCheckbox
							categoryName="All Asset Owner"
							options={assetOwnerOptions}
							id="assetOwnerId"
							isOpen={carAssetOwnerIsOpen}
							toggle={toggleCarAssetOwner}
							refetch={handleChange}
						/></Col
					>

					<Col class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold;"
							buttonText="Clear filters"
							on:click={resetFilter}
							color="secondary"
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={3} style="position:relative; padding-right:0">
				<LimitSize />

				<div class="d-flex justify-content-end">
					<LastUpdatedDateTime />
				</div>
			</Col>
		</Row>
	</Col>
</Row>
